<template>
    <div>
        <div v-html="message"/>
        <br/>

        <form-row :label="clientTerm + ' per E-Mail informieren'" label-for="send-mail" class="form-row-checkbox label-auto-width element-first no-margin" hide-validator-icon>
            <form-input-checkbox v-model="sendMail"/>
        </form-row>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue, Watch} from 'vue-facing-decorator';
    import {namespace} from 'vuex-facing-decorator';
    import FormInputCheckbox from '../../../../components/form/FormInputCheckbox.vue';
    import FormRow from '../../../../components/form/FormRow.vue';

    const CalendarStore = namespace('module/calendar');

    @Component({
        name: 'ServiceEntryInformPopUpRequest',
        components: {
            FormInputCheckbox,
            FormRow,
        },
        emits: ['input'],
    })
    export default class ServiceEntryInformPopUpRequest extends Vue
    {
        @CalendarStore.Action('setNotifyClients') setNotifyClients: (value: number) => void;

        @Prop({
            type: Number,
            default: 1,
            required: false,
        }) value: 0 | 1;

        @Prop({
            type: String,
            default: '',
            required: false,
        }) message: string;

        @Prop({
            type: String,
            default: 'Kunde',
            required: false,
        }) clientTerm: string;

        sendMail: number = 0;

        created()
        {
            this.sendMail = this.value;
        }

        @Watch('sendMail')
        watchSendMail()
        {
            this.setNotifyClients(this.sendMail);
        }
    };
</script>